import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"
import { isEqual, omit } from "lodash";

// Connects to data-controller="indicaciones-medicas-office"
export default class extends Controller {
  static values = {
    registro: Number,
    hoja: Number,
    currentDate: String,
    currentUser: String
  }

  initialize() {
    this.indicacionesOffice = [];
  }

  connect() {
    this.initialIndicacionesOffice = [];
    console.log("inicio", this.element.dataset.indicacionesOffice)
    if (this.element.dataset.indicacionesOffice.length) {
      const indicacionesOffice = JSON.parse(this.element.dataset.indicacionesOffice)
      indicacionesOffice.forEach(indicacionOffice => {
        const parsedIndicacion = JSON.parse(indicacionOffice)
        const horaColoc = new Date(parsedIndicacion.HoraColoc)
        const horaColocString = horaColoc.getHours().toString() === '0' ? '00' : horaColoc.getHours().toString()

        const indicacionMedicaOffice = {
          MaterialCodigo: parsedIndicacion.MaterialCodigo,
          farmaco: parsedIndicacion.farmaco || '',
          Interno: parsedIndicacion.Interno,
          HoraColoc: horaColocString,
          Fecha: parsedIndicacion.Fecha,
          Usuario: parsedIndicacion.Usuario || this.currentUserValue,
          destroyable: false
        };

        this.indicacionesOffice.push(indicacionMedicaOffice);
        this.initialIndicacionesOffice.push(indicacionMedicaOffice);
      });
    }

    console.log("indicacionesOffice", this.indicacionesOffice)
    console.log("initialIndicacionesOffice", this.initialIndicacionesOffice)
    console.log("document", document)

    // this.indicacionesOffice.forEach(indicacionOffice => {
    //   console.log("indicacionOffice", indicacionOffice)
    //   // document.getElementById(`${indicacionOffice.MaterialCodigo || indicacionOffice.farmaco}-${indicacionOffice.Interno}-${indicacionOffice.HoraColoc}`).checked = true;
    // })
    this.indicacionesOffice.forEach((indicacionOffice, index) => {
      try {
        const id = `${indicacionOffice.MaterialCodigo || indicacionOffice.farmaco}-${indicacionOffice.Interno}-${indicacionOffice.HoraColoc}`;
        const el = document.getElementById(id);

        if (!el) {
          console.warn(`Checkbox NO encontrado para id=${id} (index=${index})`, indicacionOffice);
          return;
        }

        el.checked = true;
      } catch (e) {
        console.error(`Error al procesar indicacion index=${index}`, indicacionOffice, e);
      }
    });
  }

  setIndicacionOffice(e) {
    e.preventDefault();

    const indicacionMedicaDetalle = JSON.parse(e.target.dataset.indicacionMedicaDetalle);
    const horaColoc = e.target.value;
    const indicacionMedicaOffice = {
      MaterialCodigo: indicacionMedicaDetalle.MaterialCodigo,
      farmaco: this.slugify(indicacionMedicaDetalle.farmaco || '') || '',
      Interno: indicacionMedicaDetalle.Interno,
      HoraColoc: horaColoc,
      Usuario: this.currentUserValue,
      Fecha: this.currentDateValue,
      destroyable: false
    };

    const isChecked = e.target.checked;

    const indicacionOfficeIndex = this.indicacionesOffice.findIndex(ind =>
      isEqual(omit(ind, ['Usuario', 'destroyable']), omit(indicacionMedicaOffice, ['Usuario', 'destroyable']))
    );

    if (isChecked) {
      if (indicacionOfficeIndex === -1) {
        this.indicacionesOffice.push(indicacionMedicaOffice);
      } else {
        this.indicacionesOffice[indicacionOfficeIndex].destroyable = false;
      }
    } else {
      if (indicacionOfficeIndex > -1) {
        const wasInitial = this.initialIndicacionesOffice.some(ind =>
          isEqual(omit(ind, ['Usuario', 'destroyable']), omit(indicacionMedicaOffice, ['Usuario', 'destroyable']))
        );

        if (wasInitial) {
          this.indicacionesOffice[indicacionOfficeIndex].destroyable = true;
        } else {
          this.indicacionesOffice.splice(indicacionOfficeIndex, 1);
        }
      }
    }

    console.log("this.indicacionesOffice", this.indicacionesOffice)
    console.log("initialIndicacionesOffice", this.initialIndicacionesOffice)
  }

  submit(e) {
    e.preventDefault();

    post('/indicaciones_medicas_office/batch_create', {
      responseKind: 'turbo-stream',
      body: {
        Registro: this.registroValue,
        Hoja: this.hojaValue,
        current_date: this.currentDateValue,
        indicaciones_medicas_office: this.indicacionesOffice
      }
    })
  }

  slugify(text) {
    if (!text) {
      return '';
    }
    return text
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '-')
      .replace(/--+/g, '-');
  }
}
